(()=>{
'use strict';
const host=document.getElementById('zlg-page-host');
if(host&&!host.shadowRoot){
 const template=host.querySelector('template');
 if(template){const root=host.attachShadow({mode:'open'});root.append(template.content.cloneNode(true));template.remove();}
}
const pageUrl="/?view=zalin-gewinnspiel";
for(const target of document.querySelectorAll('.header-links, mobile-navigation')){
 if(target.querySelector('.zlg-menu-link'))continue;
 const link=document.createElement('a');link.className='zlg-menu-link';link.href=pageUrl;link.textContent='Gewinnspiel';target.append(link);
}
const root=host?.shadowRoot;
if(root&&['#bedingungen','#datenschutz'].includes(location.hash)){const target=root.querySelector(location.hash);if(target){target.open=true;target.scrollIntoView();}}
root?.addEventListener('click',event=>{
 const link=event.target.closest?.('a[href="#bedingungen"],a[href="#datenschutz"]');
 if(!link)return;
 event.preventDefault();
 const target=root.querySelector(link.getAttribute('href'));if(target){target.open=true;target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
});
})();
(()=>{
 const root=document.getElementById('zlg-page-host')?.shadowRoot;
 if(!root||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const prizes=root.querySelectorAll('.prize');
 function reveal(prize){
   const img=prize.querySelector('.prize-art img');
   const start=()=>prize.classList.add('zlg-prize-enter');
   if(!img||img.complete)start();
   else img.addEventListener('load',start,{once:true});
 }
 if(!('IntersectionObserver' in window)){prizes.forEach(reveal);return;}
 const observer=new IntersectionObserver(entries=>{
   for(const entry of entries){
     if(!entry.isIntersecting)continue;
     observer.unobserve(entry.target);
     reveal(entry.target);
   }
 },{threshold:.15});
 prizes.forEach(prize=>observer.observe(prize));
})();

(()=>{
 const scene=document.getElementById('zlg-page-host')?.shadowRoot?.querySelector('.zlg-floating-scene');
 if(!scene||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const joyImage=new Image();
 joyImage.src="https://cdn.shopify.com/s/files/1/0799/1568/0011/files/zalin-zali-staunen-jubeln-sprites-20260930.png?v=1790748365";
 function start(){
   const begin=()=>{
     if(joyImage.naturalWidth>0)scene.classList.add('zlg-zali-reacting');
     scene.classList.add('zlg-orbit-started');
   };
   if(joyImage.complete)begin();
   else{
     joyImage.addEventListener('load',begin,{once:true});
     joyImage.addEventListener('error',begin,{once:true});
   }
 }
 if(!('IntersectionObserver' in window)){start();return;}
 const observer=new IntersectionObserver(entries=>{
   if(entries.some(entry=>entry.isIntersecting)){
     observer.disconnect();
     start();
   }
 },{threshold:.25});
 observer.observe(scene);
})();


(()=>{
 const root=document.getElementById('zlg-page-host')?.shadowRoot;
 if(!root)return;
 const start=Date.parse('2026-10-01T12:00:00+02:00'),end=Date.parse('2026-11-01T00:00:00+01:00');
 function phase(){
  const now=Date.now();
  const label=now<start?'Start am 01.10.2026 um 12 Uhr':now>=end?'Das Gewinnspiel ist beendet.':'Teilnahme bis 31.10.2026 um 23:59 Uhr';
  root.querySelectorAll('[data-zlg-phase]').forEach(el=>el.textContent=label);
 }
 phase();setInterval(phase,15000);
})();

(()=>{
 const host=document.getElementById('zlg-popup-host');
 if(!host)return;
 if(!host.shadowRoot){
  const template=host.querySelector('template');
  if(!template)return;
  const root=host.attachShadow({mode:'open'});
  root.append(template.content.cloneNode(true));template.remove();
 }
 const root=host.shadowRoot,dialog=root.querySelector('dialog'),close=root.querySelector('.close');
 if(!dialog||!close)return;
 const key='zlg-october-auto-draft-20261007-dismissed';
 const end=Date.parse('2026-11-01T00:00:00+01:00');
 let returnFocus=null,timer=null;
 const markSeen=()=>{try{sessionStorage.setItem(key,'1');}catch{}};
 function open(){
  clearTimeout(timer);
  if(Date.now()>=end||dialog.open||document.getElementById('zlg-golden-host')?.shadowRoot?.querySelector('dialog')?.open)return;
  returnFocus=document.activeElement;
  dialog.showModal();markSeen();close.focus();
 }
 document.getElementById('zlg-popup-reopen')?.addEventListener('click',open);
 close.addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{
  if(event.target!==dialog)return;
  const bounds=dialog.getBoundingClientRect();
  if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();
 });
 dialog.addEventListener('close',()=>{clearTimeout(timer);markSeen();returnFocus?.focus?.();});
 let seen=false;try{seen=sessionStorage.getItem(key)==='1';}catch{}
 if(!seen)timer=setTimeout(()=>{
  try{if(sessionStorage.getItem(key)==='1')return;}catch{}
  open();
 },700);
 function syncEnd(){
  const ended=Date.now()>=end;
  const launcher=document.getElementById('zlg-giveaway-launcher');
  if(launcher)launcher.style.display=ended?'none':'';
  if(ended&&dialog.open)dialog.close();
 }
 syncEnd();setInterval(syncEnd,15000);
})();
(()=>{
 const root=document.getElementById('zlg-popup-host')?.shadowRoot;
 const dialog=root?.querySelector('dialog');
 if(!dialog||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 const image=new Image();
 image.src="https://cdn.shopify.com/s/files/1/0799/1568/0011/files/zalin-zali-staunen-jubeln-sprites-20260930.png?v=1790748365";
 function begin(){
   if(!dialog.open||!image.naturalWidth)return;
   dialog.classList.add('zlg-popup-reacting');
 }
 function sync(){
   if(dialog.open){if(image.complete)begin();}
   else{
     dialog.classList.remove('zlg-popup-reacting','zlg-popup-motion-paused');
   }
 }
 image.addEventListener('load',begin,{once:true});
 new MutationObserver(sync).observe(dialog,{attributes:true,attributeFilter:['open']});
 sync();
})();

